export interface Plan {
    id: string
    title: string
    description: string
    highlight?: boolean
    type?: 'monthly' | 'yearly'
    currency?: string
    monthlyPrice?: number // Price in cents for monthly (e.g., $9.99 = 999)
    yearlyPrice?: number // Price in cents for yearly (e.g., $99.99 = 9999)
    priceId: string // Stripe Price ID for one-time payment or subscription
    buttonText: string
    badge?: string
    features: {
        name: string
        icon: string
        iconColor?: string
    }[]
}

export interface CurrentPlan {
    plan: Plan
    type: 'monthly' | 'yearly' | 'custom'
    price?: string
    nextBillingDate: string
    paymentMethod: string
    status: 'active' | 'inactive' | 'past_due' | 'cancelled'
}

export const plans: Plan[] = [
    {
        id: 'basic',
        title: 'Basic Plan',
        description: 'Perfect for individual investors getting started with market analysis.',
        currency: '$',
        monthlyPrice: 999, // $9.99 per month
        yearlyPrice: 9990, // $99.90 per year (2 months free)
        priceId: 'price_basic_monthly', // Stripe Price ID for Basic Plan
        buttonText: 'Start Basic',
        features: [
            {
                name: 'Real-time Market Data',
                icon: 'check',
                iconColor: 'text-green-500',
            },
            {
                name: 'Basic Stock Analysis',
                icon: 'check',
                iconColor: 'text-orange-500',
            },
            {
                name: 'Portfolio Tracking',
                icon: 'check',
                iconColor: 'text-teal-500',
            },
            {
                name: '5 Watchlists',
                icon: 'check',
                iconColor: 'text-blue-500',
            },
            {
                name: 'Email Support',
                icon: 'check',
                iconColor: 'text-zinc-500',
            },
        ],
    },
    {
        id: 'plus',
        title: 'Plus Plan',
        description: 'Advanced features for serious investors and small teams.',
        currency: '$',
        monthlyPrice: 2999, // $29.99 per month
        yearlyPrice: 29990, // $299.90 per year (2 months free)
        priceId: 'price_plus_monthly', // Stripe Price ID for Plus Plan
        buttonText: 'Go Plus',
        badge: 'Most Popular',
        highlight: true,
        features: [
            {
                name: 'Everything in Basic',
                icon: 'check',
                iconColor: 'text-green-500',
            },
            {
                name: 'Advanced Analytics',
                icon: 'check',
                iconColor: 'text-orange-500',
            },
            {
                name: 'AI-Powered Insights',
                icon: 'check',
                iconColor: 'text-teal-500',
            },
            {
                name: 'Unlimited Watchlists',
                icon: 'check',
                iconColor: 'text-blue-500',
            },
            {
                name: 'Priority Support',
                icon: 'check',
                iconColor: 'text-zinc-500',
            },
            {
                name: 'Custom Alerts',
                icon: 'check',
                iconColor: 'text-purple-500',
            },
        ],
    },
    {
        id: 'professional',
        title: 'Professional Plan',
        description: 'Complete solution for professional traders and investment firms.',
        currency: '$',
        monthlyPrice: 9999, // $99.99 per month
        yearlyPrice: 99990, // $999.90 per year (2 months free)
        priceId: 'price_professional_monthly', // Stripe Price ID for Professional Plan
        buttonText: 'Go Professional',
        features: [
            {
                name: 'Everything in Plus',
                icon: 'check',
                iconColor: 'text-green-500',
            },
            {
                name: 'Institutional Data',
                icon: 'check',
                iconColor: 'text-orange-500',
            },
            {
                name: 'Multi-Asset Analysis',
                icon: 'check',
                iconColor: 'text-teal-500',
            },
            {
                name: 'API Access',
                icon: 'check',
                iconColor: 'text-blue-500',
            },
            {
                name: 'White-label Solution',
                icon: 'check',
                iconColor: 'text-zinc-500',
            },
            {
                name: 'Dedicated Account Manager',
                icon: 'check',
                iconColor: 'text-purple-500',
            },
        ],
    },
]
